<div class="cs-root text-code" #rootElement>
  <!-- Copy overlay - outside the scrollable area -->

  <!-- Scrollable container for both line numbers and code -->
  <div class="cs-scrollable-content">
    @if (snippet.language && snippet.language !== 'typedb-console') {
      <div class="cs-line-numbers">
        <ol>
          @for (lineNumber of lineNumbers; track lineNumber) {
            <li>{{ lineNumber }}</li>
          }
        </ol>
      </div>
    }
    <div class="cs-code-area">
      <pre><code [class]="snippet.language ? 'language-' + snippet.language : undefined" [innerHTML]="snippet.code"></code></pre>
    </div>

    <div class="copy-overlay visible" (click)="copyCode()">
      <i [class]="copied() ? 'fal fa-check' : 'fal fa-copy'"></i>
    </div>
  </div>
</div>
